import { cn } from "ui/lib/utils";

export const Select = ({
  options,
  value,
  onChange,
  placeholder = "Please Select",
  className,
  ...props
}) => {
  return (
    <select
      onChange={onChange}
      value={value}
      className={cn(
        "flex min-w-[70px] h-9 items-center justify-between rounded-lg border border-white/[0.08] bg-transparent px-3 py-2 text-xs placeholder:text-white/30 focus:outline-none focus:border-white/[0.15] disabled:cursor-not-allowed disabled:opacity-40",
        className
      )}
      {...props}
    >
      {placeholder ? (
        <option value="" disabled={!value}>
          {placeholder}
        </option>
      ) : null}
      {options.map(({ value, label }) => (
        <option key={value} value={value}>
          {label || value}
        </option>
      ))}
    </select>
  );
};
